import { useOverlayTrigger } from '@react-aria/overlays';
import React__default, { useRef, useEffect, useMemo } from 'react';
import { useOverlayTriggerState } from '@react-stately/overlays';
import { SwanPopoverContextProvider } from './popover.context.js';

/**
 * This is NOT a public component.
 * It is intended to be used by listbox and combobox and may not be accessible on it's own
 */ const PopoverInternal = (props)=>{
    const { children , expanded , popoverPlacement  } = props;
    const popoverRef = useRef(null);
    const triggerRef = useRef(null);
    const overlayState = useOverlayTriggerState({});
    const { overlayProps , triggerProps  } = useOverlayTrigger({
        type: 'dialog'
    }, overlayState, triggerRef);
    useEffect(()=>{
        if (expanded) {
            overlayState.open();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        expanded
    ]);
    const contextValue = useMemo(()=>({
            popoverRef,
            triggerRef,
            overlayState,
            overlayProps: overlayProps,
            triggerProps: triggerProps,
            popoverPlacement
        }), [
        triggerRef,
        popoverRef,
        overlayState,
        overlayProps,
        triggerProps,
        popoverPlacement
    ]);
    return /*#__PURE__*/ React__default.createElement(SwanPopoverContextProvider, {
        value: contextValue
    }, children);
};

export { PopoverInternal };
